import React, { Dispatch, SetStateAction } from "react"
import { EditorQuill } from "../../../../components/EditorQuill/EditorQuill"
import { Input } from "../../../../components/Input/Input"
import { i18n } from "../../../../translate/i18n"
import { ContentCreate, ContentField } from "../dinamyc-pages.types"
import { GridCarousel } from "./gridCarosel"
import { GridImage } from "./gridImage"




export const ContentFieldInput = ({
    config,
    data,
    setData,
}: {
    config: ContentField
    data: ContentCreate
    setData: Dispatch<SetStateAction<ContentCreate>>
}) => {

    const change = (value: any) => {
        const newValue = value.image?  value.image : value

        setData((prev) => ({
            ...prev,
            [config.field]: newValue,
        }))
    }

    switch (config.field) {
        case 'title':
            return (
                <Input
                    inputAttr={{
                        type: 'text',
                        className: 'form-control',
                    }}
                    label={i18n.t('agregador_dinamic_page.form.title_label')}
                    placeholder={i18n.t('agregador_dinamic_page.form.title_placeholder')}
                    value={data.title}
                    change={change}
                />
            )

        case 'text':
            return (
                <EditorQuill
                    value={data.text}
                    change={change}
                    maxLength={config.maxLength ?? 500}
                />
            )

        case 'image':
            return (
                <GridImage
                    data={data}
                    setData={change}
                />
            )

        case 'images':
            return (
                <GridCarousel
                    data={data}
                    min={config.min}
                    max={config.max}
                    setData={change}
                />
            )

        default:
            return null
    }
}